// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__U8npk","text":"SelectPayment_text__1OPlF","title":"SelectPayment_title__1XWi-","btn":"SelectPayment_btn__322ZN"};